/* TooCut PDP v3.3 — buy box, accordion, featured reviews carousel,
   sticky mobile CTA, idle preloads, per-product rating override,
   selling plan plumbing, Mux player IG-style autoplay-on-scroll.
   v3.1 fix: empty cart → first add → drawer opens but visually empty.
   v3.2: Pack-tile sub-labels update on mode toggle.
     - sub mode: 1pk='monthly', 3pk='every 3 mo', 6pk='every 6 mo'
     - one-time: 1pk='' (NBSP for layout), 3pk='3 month supply', 6pk='6 month supply'
   v3.3: Presentment-currency conversion for hardcoded USD prices.
     - Reads Shopify.currency.active + Shopify.currency.rate (Shopify Markets globals)
     - fmtMoney(usdAmount) → 'CA$143.00', 'US$104.50', '£82.00', '€94.50', '¥15,600' etc.
     - Zero-decimal currencies (JPY, KRW, HUF, etc.) rendered without decimals per Shopify spec
     - Fallback: rate=1, active='USD' if Shopify.currency missing (no regression)
     - MutationObserver on .tcp-addon__price-amt catches inline addon-card script writes
     - .tcp.currency-ready class added post-conversion (paired with CSS visibility rule
       in toocut-product-v2.css to eliminate USD flash-of-unformatted-price on load)
*/
(function() {
  var root = document.querySelector('.tcp');
  if (!root) return;

  // ---- v3.3 CURRENCY CONVERSION ----
  var SC = (window.Shopify && window.Shopify.currency) || {};
  var activeCode = (SC.active || 'USD').toUpperCase();
  var rate = parseFloat(SC.rate) || 1.0;
  // Currencies with no fractional digits (per ISO 4217 + Shopify's zero-decimal list)
  var ZERO_DEC = { JPY:1, KRW:1, HUF:1, ISK:1, CLP:1, VND:1, XOF:1, XAF:1, XPF:1, RWF:1, UGX:1, VUV:1, DJF:1, KMF:1, PYG:1, BIF:1, GNF:1, UYI:1 };
  // Prefix table — unambiguous. Currencies not listed fall through to ISO_code + space + amount.
  var PREFIX = {
    USD:'US$', CAD:'CA$', AUD:'A$', NZD:'NZ$', SGD:'S$', HKD:'HK$',
    GBP:'£', EUR:'€', JPY:'¥', KRW:'₩', ILS:'₪',
    CHF:'CHF ', SEK:'kr ', DKK:'kr ', NOK:'kr ', PLN:'zł ', CZK:'Kč ',
    AED:'AED ', MYR:'RM ', INR:'₹'
  };
  function fmtMoney(usd) {
    if (isNaN(usd)) usd = 0;
    var val = usd * rate;
    var decimals = ZERO_DEC[activeCode] ? 0 : 2;
    var num = decimals === 0 ? String(Math.round(val)) : val.toFixed(2);
    // Thousands separator (naive, safe for our range)
    var parts = num.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var formatted = parts.join('.');
    var prefix = PREFIX[activeCode] || (activeCode + ' ');
    return prefix + formatted;
  }
  // ----------------------------------

  (function setRating() {
    var meta = root.querySelector('.tcp-toprating__meta');
    if (!meta) return;
    var m = window.location.pathname.match(/\/products\/([^\/?]+)/);
    if (!m) return;
    var handle = m[1].replace('-m2-preview', '');
    var ratings = {
      'toocut-women-s-amplifier': '4.74 · 18,000+ verified buyers',
      'toocut-men-s-amplifier':   '4.89 · 19,000+ verified buyers',
      'toocut-detox':             '4.91 · 10,000+ verified buyers',
      'toocut-brain-booster':     '4.93 · 8,500+ verified buyers',
      'toocut-crown-elixir':      '5.00 · 1,200+ verified buyers'
    };
    var r = ratings[handle];
    if (r) meta.textContent = r;
  })();

  var mode = 'sub';
  var pack = 3;
  // v3.3: fmt() now delegates to fmtMoney() so all downstream price rendering
  // (pack tiles, main CTA, sticky CTA, price row) picks up presentment currency automatically.
  var fmt = function(n) { return fmtMoney(n); };

  function $(sel, ctx) { return (ctx || root).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || root).querySelectorAll(sel)); }

  function readPriceData(card, m, p) { return parseFloat(card.getAttribute('data-' + m + '-' + p)); }
  function readAnchor(card, p) { return parseFloat(card.getAttribute('data-anchor-' + p)); }
  function readSellingPlan(card, p) { return parseInt(card.getAttribute('data-selling-plan-' + p), 10) || null; }

  $$('.tcp-mode__btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var newMode = btn.dataset.mode;
      if (newMode === mode) return;
      mode = newMode;
      $$('.tcp-mode__btn').forEach(function(b) { b.classList.toggle('is-active', b === btn); });
      renderBuyBox();
    });
  });

  $$('.tcp-pack').forEach(function(btn) {
    btn.addEventListener('click', function() {
      if (btn.disabled) return;
      var p = parseInt(btn.dataset.pack, 10);
      pack = p;
      $$('.tcp-pack').forEach(function(b) { b.classList.toggle('is-active', b === btn); });
      renderBuyBox();
    });
  });

  function renderBuyBox() {
    $$('.tcp-pack').forEach(function(card) {
      var p = parseInt(card.dataset.pack, 10);
      var sub = readPriceData(card, 'sub', p);
      var one = readPriceData(card, 'one', p);
      var price = mode === 'sub' ? sub : one;
      var priceEl = card.querySelector('.tcp-pack__price');
      if (priceEl) priceEl.textContent = fmt(price);
      var saveEl = card.querySelector('.tcp-pack__save');
      if (saveEl) {
        var saveVal = parseInt(mode === 'sub' ? saveEl.dataset.saveSub : saveEl.dataset.saveOne, 10) || 0;
        if (saveVal > 0) {
          // v3.3: save badge shows converted amount too. Round the whole-dollar save
          // through fmtMoney so it displays 'save CA$14' etc. instead of 'save $14'.
          saveEl.textContent = 'save ' + fmtMoney(saveVal).replace(/[.,]00$/, '');
          saveEl.style.display = '';
        } else {
          saveEl.style.display = 'none';
        }
      }
      // v3.2: pack-tile sub-label swap per mode
      var subEl = card.querySelector('.tcp-pack__sub');
      if (subEl) {
        var subText;
        if (mode === 'sub') {
          subText = p === 1 ? 'monthly' : ('every ' + p + ' mo');
        } else {
          subText = p === 1 ? ' ' : (p + ' month supply');
        }
        subEl.textContent = subText;
      }
    });

    var packData = $('.tcp-pack[data-pack="' + pack + '"]');
    if (!packData) return;
    var sub = readPriceData(packData, 'sub', pack);
    var one = readPriceData(packData, 'one', pack);
    var anchor = readAnchor(packData, pack);
    var price = mode === 'sub' ? sub : one;
    var compare = (anchor && anchor > price) ? anchor : null;

    var priceEl = $('.tcp-price');
    var compareEl = $('.tcp-price-compare');
    var metaEl = $('.tcp-price-meta');
    var ctaEl = $('.tcp-cta');

    if (priceEl) priceEl.textContent = fmt(price);
    if (compareEl) {
      if (compare && compare > price) { compareEl.textContent = fmt(compare); compareEl.style.display = ''; }
      else { compareEl.style.display = 'none'; }
    }
    if (metaEl) {
      metaEl.textContent = pack + '-pack · ' + (mode === 'sub' ? (pack === 1 ? 'monthly delivery' : 'every ' + pack + ' months') : pack + ' mo supply');
    }
    if (ctaEl) {
      var variantId = packData.dataset.variantId;
      if (variantId && variantId !== '') {
        ctaEl.disabled = false;
        ctaEl.textContent = 'Add to Cart — ' + fmt(price);
        ctaEl.dataset.variantId = variantId;
      } else {
        ctaEl.disabled = true;
        ctaEl.textContent = 'Variant unavailable';
      }
    }

    var stickyPriceMain = $('.tcp-sticky__price-main');
    var stickyPriceMeta = $('.tcp-sticky__price-meta');
    var stickyCta = $('.tcp-sticky__cta');
    if (stickyPriceMain) stickyPriceMain.textContent = fmt(price);
    if (stickyPriceMeta) stickyPriceMeta.textContent = pack + '-pack · ' + (mode === 'sub' ? 'sub' : 'one-time');
    if (stickyCta) {
      stickyCta.disabled = ctaEl ? ctaEl.disabled : false;
      stickyCta.dataset.variantId = (ctaEl && ctaEl.dataset.variantId) || '';
    }
  }

  function getDrawerSectionIds() {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      return drawer.getSectionsToRender().map(function(s) { return s.id; });
    }
    return ['cart-drawer', 'cart-icon-bubble'];
  }

  function addToCart(triggerBtn) {
    if (!triggerBtn || triggerBtn.disabled) return;
    var variantId = triggerBtn.dataset.variantId;
    if (!variantId) return;
    var originalText = triggerBtn.textContent;
    triggerBtn.disabled = true;
    triggerBtn.textContent = 'Adding…';

    var packData = $('.tcp-pack[data-pack="' + pack + '"]');
    var sellingPlanId = null;
    if (mode === 'sub' && packData) {
      sellingPlanId = readSellingPlan(packData, pack);
    }
    var mainItem = { id: parseInt(variantId, 10), quantity: 1 };
    if (sellingPlanId) mainItem.selling_plan = sellingPlanId;

    var body = {
      items: [mainItem],
      sections: getDrawerSectionIds().join(','),
      sections_url: window.location.pathname
    };

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(body)
    }).then(function(r) {
      return r.json().then(function(data) { return { ok: r.ok, data: data }; });
    }).then(function(resp) {
      if (!resp.ok) {
        var msg = (resp.data && (resp.data.description || resp.data.message)) || 'Cart add failed';
        throw new Error(msg);
      }
      triggerBtn.textContent = '✓ Added to cart';
      document.dispatchEvent(new CustomEvent('cart:refresh'));

      var drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.renderContents === 'function' && resp.data && resp.data.sections) {
        drawer.renderContents(resp.data);
        if (drawer.classList.contains('is-empty')) {
          drawer.classList.remove('is-empty');
        }
      } else if (drawer && typeof drawer.open === 'function') {
        drawer.open();
      }

      setTimeout(function() {
        triggerBtn.disabled = false;
        triggerBtn.textContent = originalText;
      }, 1800);
    }).catch(function(err) {
      triggerBtn.disabled = false;
      triggerBtn.textContent = 'Try again';
      console.error('Cart add failed:', err);
    });
  }

  var ctaBtn = $('.tcp-cta');
  if (ctaBtn) ctaBtn.addEventListener('click', function() { addToCart(ctaBtn); });
  var stickyBtn = $('.tcp-sticky__cta');
  if (stickyBtn) stickyBtn.addEventListener('click', function() { addToCart(stickyBtn); });

  var stickyEl = $('.tcp-sticky');
  function updateStickyVisibility() {
    if (!stickyEl) return;
    if (window.innerWidth > 749) { stickyEl.classList.remove('is-visible'); return; }
    if (!ctaBtn) return;
    var rect = ctaBtn.getBoundingClientRect();
    if (rect.bottom < window.innerHeight * 0.3) {
      stickyEl.classList.add('is-visible');
      stickyEl.setAttribute('aria-hidden', 'false');
    } else {
      stickyEl.classList.remove('is-visible');
      stickyEl.setAttribute('aria-hidden', 'true');
    }
  }
  window.addEventListener('scroll', updateStickyVisibility, { passive: true });
  window.addEventListener('resize', updateStickyVisibility);

  function idlePreload() {
    $$('.tcp-gallery__thumb').forEach(function(thumb) {
      var src = thumb.dataset.full;
      if (src) { var im = new Image(); im.src = src; }
    });
    $$('.tcp-acc__ing-img img').forEach(function(img) {
      if (img.src) { var im = new Image(); im.src = img.src; }
    });
    $$('.tcp-featrev__photo img').forEach(function(img) {
      if (img.src) { var im = new Image(); im.src = img.src; }
    });
  }
  if ('requestIdleCallback' in window) { requestIdleCallback(idlePreload, { timeout: 2500 }); }
  else { setTimeout(idlePreload, 1500); }

  $$('.tcp-gallery__thumb').forEach(function(thumb) {
    thumb.addEventListener('click', function() {
      var mainImg = $('.tcp-gallery__main img');
      if (mainImg) {
        mainImg.classList.add('is-swapping');
        setTimeout(function() { mainImg.classList.remove('is-swapping'); }, 200);
      }
    }, true);
  });

  (function carousel() {
    var viewport = $('.tcp-featrevs__viewport');
    var track = $('.tcp-featrevs__track');
    if (!viewport || !track) return;
    var slides = $$('.tcp-featrev', track);
    if (slides.length === 0) return;
    var dotsEl = $('.tcp-featrevs__dots');
    var idx = 0;
    var autoTimer = null;
    var AUTO_MS = 4000;
    function buildDots() {
      if (!dotsEl) return;
      dotsEl.innerHTML = '';
      slides.forEach(function(_, i) {
        var d = document.createElement('button');
        d.type = 'button';
        d.className = 'tcp-featrevs__dot' + (i === 0 ? ' is-active' : '');
        d.setAttribute('aria-label', 'Go to review ' + (i + 1));
        d.addEventListener('click', function() { goTo(i, true); });
        dotsEl.appendChild(d);
      });
    }
    function goTo(i, userInitiated) {
      idx = (i + slides.length) % slides.length;
      track.style.transform = 'translateX(-' + (idx * 100) + '%)';
      $$('.tcp-featrevs__dot', dotsEl).forEach(function(d, n) { d.classList.toggle('is-active', n === idx); });
      if (userInitiated) restartAuto();
    }
    function next() { goTo(idx + 1, false); }
    function prev() { goTo(idx - 1, true); }
    function startAuto() { stopAuto(); autoTimer = setInterval(next, AUTO_MS); }
    function stopAuto() { if (autoTimer) { clearInterval(autoTimer); autoTimer = null; } }
    function restartAuto() { stopAuto(); startAuto(); }
    var prevBtn = $('.tcp-featrevs__arrow--prev');
    var nextBtn = $('.tcp-featrevs__arrow--next');
    if (prevBtn) prevBtn.addEventListener('click', function() { prev(); });
    if (nextBtn) nextBtn.addEventListener('click', function() { goTo(idx + 1, true); });
    var startX = null;
    viewport.addEventListener('touchstart', function(e) { startX = e.touches[0].clientX; stopAuto(); }, { passive: true });
    viewport.addEventListener('touchend', function(e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 40) { if (dx < 0) goTo(idx + 1, true); else prev(); } else { startAuto(); }
      startX = null;
    }, { passive: true });
    viewport.addEventListener('mouseenter', stopAuto);
    viewport.addEventListener('mouseleave', startAuto);
    buildDots();
    startAuto();
  })();

  // Mux IG-style autoplay-on-scroll + audio-follows-scroll
  function setupMuxAutoplay() {
    var muxNodes = $$('mux-player.tcp-vid__mux');
    if (muxNodes.length === 0) return;
    var audioOn = false;
    var explicitTarget = null;
    var ratios = new Map();
    muxNodes.forEach(function(p) { ratios.set(p, 0); });

    function getCard(player) { return player.closest('.tcp-vid'); }
    function setCardUnmutedUI(card, isUnmuted) {
      if (!card) return;
      card.classList.toggle('is-unmuted', isUnmuted);
    }
    function getMostVisible() {
      var max = -1, winner = null;
      muxNodes.forEach(function(p) {
        var r = ratios.get(p) || 0;
        if (r > max) { max = r; winner = p; }
      });
      return winner;
    }
    function getAudioTarget() {
      if (!audioOn) return null;
      if (explicitTarget && (ratios.get(explicitTarget) || 0) >= 0.5) return explicitTarget;
      return getMostVisible();
    }
    function applyAudioRouting() {
      var target = getAudioTarget();
      muxNodes.forEach(function(p) {
        var shouldMute = (p !== target);
        try { p.muted = shouldMute; } catch (e) {}
        setCardUnmutedUI(getCard(p), !shouldMute);
      });
    }

    muxNodes.forEach(function(player) {
      var card = getCard(player);
      var unmuteBtn = card ? card.querySelector('.tcp-vid__unmute') : null;
      if (!unmuteBtn) return;
      unmuteBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        if (audioOn && explicitTarget === player) {
          audioOn = false;
          explicitTarget = null;
        } else {
          audioOn = true;
          explicitTarget = player;
        }
        applyAudioRouting();
      });
    });

    if (!('IntersectionObserver' in window)) {
      muxNodes.forEach(function(p) { try { p.play(); } catch (e) {} });
      return;
    }
    var io = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        var player = entry.target;
        ratios.set(player, entry.intersectionRatio);
        try {
          if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
            player.play && player.play().catch(function() {});
          } else {
            player.pause && player.pause();
          }
        } catch (e) {}
      });
      if (audioOn) applyAudioRouting();
    }, { threshold: [0, 0.25, 0.5, 0.75, 1] });
    muxNodes.forEach(function(p) { io.observe(p); });
    applyAudioRouting();
  }
  if (window.customElements && window.customElements.whenDefined) {
    window.customElements.whenDefined('mux-player').then(setupMuxAutoplay).catch(setupMuxAutoplay);
  } else {
    setTimeout(setupMuxAutoplay, 1000);
  }

  $$('.tcp-vid').forEach(function(card) {
    var btn = card.querySelector('.tcp-vid__play');
    var vid = card.querySelector('.tcp-vid__video');
    if (!btn || !vid) return;
    btn.addEventListener('click', function() {
      btn.style.display = 'none';
      vid.setAttribute('controls', '');
      try { vid.play(); } catch (e) {}
    });
  });

  var mainImg = $('.tcp-gallery__main img');
  $$('.tcp-gallery__thumb').forEach(function(thumb) {
    thumb.addEventListener('click', function() {
      var src = thumb.dataset.full || thumb.querySelector('img').src;
      if (mainImg) mainImg.src = src;
      $$('.tcp-gallery__thumb').forEach(function(t) { t.classList.toggle('is-active', t === thumb); });
    });
  });

  // v3.3: Addon cards initial render + MutationObserver.
  // Addon cards render initial prices via Liquid {{ ap_price_sub | times:100 | money }}
  // which outputs USD. The inline addon script (in the section liquid) also uses a
  // '$' + n.toFixed(2) formatter when toggling Sub/One-time. This block converts the
  // initial values on load AND observes subsequent writes to re-format them.
  (function convertAddonCards() {
    var addons = document.querySelectorAll('.tcp-addon');
    if (!addons.length) return;
    function apply(card) {
      var amt = card.querySelector('.tcp-addon__price-amt');
      var modeEl = card.dataset.mode || 'sub';
      var usdPrice = parseFloat(modeEl === 'sub' ? card.dataset.subPrice : card.dataset.onePrice);
      if (!amt || isNaN(usdPrice)) return;
      var target = fmtMoney(usdPrice);
      if (amt.textContent !== target) amt.textContent = target;
    }
    addons.forEach(function(card) {
      apply(card);
      var amt = card.querySelector('.tcp-addon__price-amt');
      if (!amt || !('MutationObserver' in window)) return;
      var isReconciling = false;
      var mo = new MutationObserver(function() {
        if (isReconciling) return;
        // Detect if the current text is a bare '$X.XX' pattern (inline script wrote it)
        if (/^\$\d/.test(amt.textContent.trim())) {
          isReconciling = true;
          apply(card);
          isReconciling = false;
        }
      });
      mo.observe(amt, { childList: true, characterData: true, subtree: true });
    });
  })();

  renderBuyBox();
  updateStickyVisibility();

  // v3.3: Mark PDP as currency-ready. CSS in toocut-product-v2.css can hide prices
  // via `.tcp:not(.currency-ready) .tcp-pack__price` etc. to eliminate the USD
  // flash-of-unformatted-price window (~50-100ms on mobile).
  root.classList.add('currency-ready');
})();
